module.exports = __webpack_public_path__ + "static/media/MyPres.61e6997b.md";